import { jsxs, jsx } from "react/jsx-runtime";
import Brand from "../../../../../../graphics/Brand/Brand.js";
import "../../../../../../graphics/Brand/items/IdaLogo.js";
import "../../../../../../graphics/Brand/items/MitIdaLogo.js";
import "../../../../../../graphics/Brand/items/IdaForsikringLogo.js";
import Group from "../../../../../../layout/Group/Group.js";
import TextLink from "../../../../../../navigation/TextLink/TextLink.js";
import { L as LocalNavbarStyles } from "../../../../../../../LocalNavbar.module-D_uZkV8K.js";
import { useTracking } from "../../../../../../../hooks/useTracking.js";
import NavbarMiddle from "./NavbarMiddle.js";
const DesktopNavbar = (props) => {
  const {
    isLoading,
    user,
    actionLink,
    logo,
    links,
    search,
    openDropdownsHandlers,
    openDropdowns,
    visibleFrom,
    showUserLogin
  } = props;
  const tracker = useTracking();
  const handleClick = (text, url) => {
    tracker == null ? void 0 : tracker.page.navigate({
      type: "header",
      action: text,
      destination: url
    });
    openDropdownsHandlers.apply(() => false);
  };
  return /* @__PURE__ */ jsxs(
    Group,
    {
      align: "center",
      justify: "space-between",
      className: LocalNavbarStyles.innerWrapper,
      visibleFrom,
      children: [
        /* @__PURE__ */ jsx(
          Brand,
          {
            name: (logo == null ? void 0 : logo.icon) || "IdaLogo",
            variant: "light",
            href: (logo == null ? void 0 : logo.href) || "/",
            target: logo == null ? void 0 : logo.target,
            onClick: () => handleClick("IDA Logo", (logo == null ? void 0 : logo.href) || ""),
            width: "auto",
            height: 27
          }
        ),
        /* @__PURE__ */ jsx(
          NavbarMiddle,
          {
            openDropdownsHandlers,
            isLoading,
            actionLink,
            openDropdowns,
            showUserLogin,
            links,
            handleClick,
            user
          }
        ),
        /* @__PURE__ */ jsx(Group, { align: "center", spacing: "md", className: LocalNavbarStyles.right, children: search && /* @__PURE__ */ jsx(
          TextLink,
          {
            weight: 600,
            color: "light",
            icon: "Search",
            iconPlacement: "left",
            target: search.target,
            href: search.href,
            variant: "component",
            onClick: () => handleClick(search.text, search.href)
          }
        ) })
      ]
    }
  );
};
export {
  DesktopNavbar as default
};
